import { FC } from 'react';

import { Box, Paper, Typography } from '@mui/material';

import { getBusinessPlanIconDetailsByType } from 'pages/Workspace/helpers/getBusinessPlanIconByType';

import projectCardTemplateImage from 'assets/images/projectCardTemplateImage.jpeg';

import { IBusinessPlanEntity } from 'interfaces/businessPlan';

import { Loader } from 'components/_basic/Loader/Loader';

import { CardLowerSection } from '../CardLowerSection/CardLowerSection';

import styles from './BusinessPlanProjectCard.module.scss';

export const BusinessPlanProjectCard: FC<IBusinessPlanEntity> = (props) => {
  const { businessPlanOption, cssVariables, icon } = getBusinessPlanIconDetailsByType(props.type);

  if (!businessPlanOption) {
    return null;
  }

  return (
    <Paper elevation={0} className={styles.wrapper} style={cssVariables}>
      <Box className={styles.upperCard}>
        <Box className={styles.companyLogoStyles}>
          <Box className={styles.icon}>{icon}</Box>
        </Box>
        <Box className={styles.companyDetailsStyles}>
          <Typography variant="h6" className={styles.companyNameStyles}>
            {props.companyName || props.title}
          </Typography>
          <Typography variant="body2" className={styles.companyDescriptionStyles}>
            {props.coverTitle}
          </Typography>
        </Box>
        <Box className={styles.imageContainer}>
          {props?.isPictureLoading ? (
            <Loader size={20} />
          ) : (
            <img
              src={props.picture}
              className={styles.image}
              alt="Document background picture"
              onError={(event) => {
                const img = event.target as HTMLImageElement;
                img.src = projectCardTemplateImage;
              }}
            />
          )}
        </Box>
      </Box>
      <CardLowerSection {...props} />
    </Paper>
  );
};
